$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const initialSlide = urlParams.get('slide') ? parseInt(urlParams.get('slide'), 10) : 1;

  $('.custom-hero__blocks').slick({
    slidesToShow: 2,
    variableWidth: true,
    centerMode: true,
    initialSlide: initialSlide,
    arrows: true,
    infinite: true,
    prevArrow: $('.custom-hero_prev'),
    nextArrow: $('.custom-hero_next')
  });

  function updateSlideClasses() {
    $('.custom-hero__block').removeClass('not-active-slide prev next');
    $('.slick-slide').removeClass('prev next');

    const currentSlide = $('.slick-current .custom-hero__block');
    currentSlide.prev('.slick-slide').addClass('prev');
    currentSlide.next('.slick-slide').addClass('next');

    const bgColor = currentSlide.data('bg-color');
    $('.custom-hero, .header-wrapper').css('background-color', bgColor);
  }

  updateSlideClasses();

  $('.custom-hero__blocks').on('afterChange', function(event, slick, currentSlide){
    updateSlideClasses();
  });
});